import { lazy, Suspense } from "react";
import AuthLayout from "../layout/AuthLayout";
import { Routes, Route, Navigate } from "react-router-dom";
import PageLoading from "../components/PageLoading";
import DashboardLayout from "../layout/DashboardLayout";
import PrivateRoute from "./PrivateRoute";

export const routes = [
  {
    path: "/",
    layout: AuthLayout,
    element: lazy(() => import("../pages/auth/loginForm")),
    isPrivateRoute: false,
  },
  {
    path: "/dashboard",
    layout: DashboardLayout,
    element: lazy(() => import("../pages/dashboard")),
    isPrivateRoute: true,
  },
  {
    path: "/policy-list",
    layout: DashboardLayout,
    element: lazy(() => import("../pages/policyList")),
    isPrivateRoute: true,
  },
  {
    path: "/claims",
    layout: DashboardLayout,
    element: lazy(() => import("../pages/claims")),
    isPrivateRoute: true,
  },
  {
    path: "/claimstatus",
    layout: DashboardLayout,
    element: lazy(() => import("../pages/claimstatus")),
    isPrivateRoute: true,
  },
  {
    path: "/policy-status",
    layout: DashboardLayout,
    element: lazy(() => import("../pages/policystatus")),
    isPrivateRoute: true,
  },
  {
    path: "/change-password",
    layout: DashboardLayout,
    element: lazy(() => import("../pages/auth/chnagePassword")),
    isPrivateRoute: true,
  },
];

const RouteConfig = () => {
  return (
    <Suspense fallback={<PageLoading />}>
      <Routes>
        {routes.map((route, index) => {
          const Element = (
            <route.layout>
              <route.element />
            </route.layout>
          );

          return (
            <Route
              key={index}
              path={route.path}
              element={
                route.isPrivateRoute ? (
                  <PrivateRoute>{Element}</PrivateRoute>
                ) : (
                  Element
                )
              }
            />
          );
        })}
        {/* Catch-all route: redirect any unknown path to home ("/") */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Suspense>
  );
};

export default RouteConfig;
